import React, { Component } from 'react';
import { connect } from 'react-redux';
import { changeSort } from '../../../services/carts/actions';

class Filter extends Component{
    
    render(){
        return (
            <div className="mb-3 d-flex flex-wrap">
                {
                    this.props.availables.map(tag => {
                        let classNames = ["tag"];
                        if( this.props.selected.includes(tag) ){
                            classNames.push("active");
                        }
                        return <span className={classNames.join(' ')} role="button" key={tag} onClick={() => this.props.changeSort(tag)} >{tag}</span>
                    })
                }
            </div>
        );
    }
}

const mapStateToProps = state => ({
    selected: state.carts.sort.selected,
    availables: state.carts.sort.availables
});

export default connect(
    mapStateToProps,
    {changeSort}
)(Filter);